import React from 'react';
import RefreshIndicator from 'material-ui/RefreshIndicator';

class LoadingIndicator extends React.Component {

  render()  {
    return (
      <div style={{ flex: '1', alignItems: 'center', justifyContent: 'center', display: this.props.display, height: '40vh' }}>
        <div style={{ position: 'relative', alignSelf: 'center'}}>
          <RefreshIndicator
            size={40}
            left={-20}
            top={0}
            status='loading'
            style={{marginLeft: '50%'}}
          />
        </div>
      </div>
    );
  }

}

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/Navigation/LoadingIndicator.js